import React from "react"
import {Avatar} from "@chakra-ui/react"

import {CatIcon} from "@components/app"
import {IconNameExt} from "@utils/icons"
import {GameInfo} from "@backend/types"

type GameTitleProps = {
    info: GameInfo,
    extra?: React.ReactNode
}

export function GameTitle({info, extra}: GameTitleProps) {

    return <div className="flex items-center">
        <Avatar
            bg={info.color}
            className="mr-4"
            icon={<CatIcon icon={info.icon as IconNameExt || "blender"} iconSize="lg"/>}/>
        <div className="flex flex-col justify-start items-start space-y-1">
            <span>{info.title}</span>
            {extra}
        </div>
    </div>
}